import { PRODUCT_CARD } from '~/lib/fetch-links'
import Storyblok, { pageSbParams } from '~/lib/storyblok'

/**
 * fetches a story by its uuid if needed
 * @param {string | Record<string, any>} data - string | Record<string, any>
 * @param {any} [params] - The params to pass to the Storyblok.get method.
 * @returns A function that returns a promise that resolves to a story object.
 */
export default async function getByUuid(
  uuid: string | Record<string, any>,
  params?: Record<string, any>,
) {
  if (typeof uuid === 'string') {
    if (uuid === '') return null

    try {
      const fetchData = await Storyblok.getStory(uuid, {
        find_by: 'uuid',
        version: 'published',
        resolve_relations: [...PRODUCT_CARD],
        ...(pageSbParams.instance ?? {}),
        ...params,
      })

      return fetchData?.data?.story ?? null
    } catch (error) {
      console.error(error)
    }
  } else {
    return uuid ?? null
  }
}
